import { IHomeIcon } from '../../../interfaces/HomeIcon.interfaces';
import { customAxios } from '../../common/customAxios';
export const getHomeIcons = (): Promise<IHomeIcon[]> => {
  return customAxios.get(`/home-icons`);
};
